export default class Plugin {
    constructor(opts) {
        this.opts = opts;
    }
    setCore(core) {
        this.core = core;
        return this;
    }
    install() { }
    uninstall() { }
}



// WEBPACK FOOTER //
// ./app/webpack/vendor/formvalidation-1.3.0/dist/es6/core/Plugin.js